import Cookies from "./cookies";

type UserRole = 0 | 1 | 2 | "";

// Allow saving type-specific prev urls
// Usage: Set different prev urls for different user types
export const setPrevUrlCookie = (url = window.location.href, role: UserRole = "") => {
  if (window.location.pathname !== "/") {
    Cookies.setItem(`prevUrl${role}`, url, { expires: 1800, path: "/" });
  }
};

export const getPrevUrlCookie = (
  targetLink: string,
  deletePrev = true,
  role: UserRole = "",
  shouldRedirect = true
) => {
  // Try type-specific url before general url
  const prevUrl = Cookies.getItem(`prevUrl${role}`) ?? Cookies.getItem(`prevUrl`);
  if (prevUrl) {
    if (deletePrev) {
      // Make sure to clean up all general and type-specific urls
      Cookies.removeItem("prevUrl", "/");
      Cookies.removeItem("prevUrl0", "/");
      Cookies.removeItem("prevUrl1", "/");
      Cookies.removeItem("prevUrl2", "/");
    }

    if (!shouldRedirect) {
      return prevUrl;
    }

    if (window.location.href === prevUrl) {
      location.reload();
    } else {
      window.location.href = prevUrl;
    }
  } else if (shouldRedirect) {
    window.location.href = targetLink;
  }
};

const SIGNUP_PREFILL_EMAIL_KEY = "signup_prefill_email";

export const setSignupPrefillEmailCookie = (email: string): void => {
  Cookies.setItem(SIGNUP_PREFILL_EMAIL_KEY, email, { expires: 1800, path: "/" });
};

export const popSignupPrefillEmailCookie = (): string => {
  const prefill = Cookies.getItem(SIGNUP_PREFILL_EMAIL_KEY) ?? "";
  Cookies.removeItem(SIGNUP_PREFILL_EMAIL_KEY, "/");
  return prefill;
};

const SIGNUP_ENTRY_KEY = "sign_up_entry_point";

export const setSignupEntryCookie = (source: string): void => {
  Cookies.setItem(SIGNUP_ENTRY_KEY, source, { expires: 1800, path: "/" });
};

export const popSignupEntryCookie = (): string => {
  const source = Cookies.getItem(SIGNUP_ENTRY_KEY) ?? "";
  Cookies.removeItem(SIGNUP_ENTRY_KEY, "/");
  return source;
};
